import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/home-main.svg";
import Tilt from "react-parallax-tilt";
import { IoMail } from "react-icons/io5";
import {
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { 
  FaLinkedinIn,
 } from "react-icons/fa";

 import { 
  SiUpwork ,
 } from "react-icons/si";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Every <span className="red"> Moment </span>Counts!
            </h1>
            <p className="home-about-body">
              Time is your most valuable asset—especially in today’s fast-moving digital world, where delays can compromise security, performance, and client trust.            
              <br />
              <br />At RedDawg Tech, we go beyond traditional consulting. We provide expert
              <i>
                <b className="red"> Software development, DevOps optimization, and Cybersecurity solutions  </b>
              </i>
              designed to keep your systems running smoothly and securely.
              <br />
              <br />
              From proactive monitoring to hands-on troubleshooting, our experienced engineers step in before issues escalate, ensuring your operations stay uninterrupted. 
              <br />
              <br />
              Because in technology, 
              <b className="red"> EVERY </b> moment truly counts.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <p>
              Feel free to <span className="red">connect</span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://x.com/reddawgtechllc?s=21"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/company/reddawgtech"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/reddawgtechllc"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.upwork.com/agencies/1965958052728851887/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <SiUpwork  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:support@reddawgtech.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <IoMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
